import type { FaireProductEntity } from "../../entity_types/product";

export const p_tsyjmkxkq4: FaireProductEntity = {
  token: "p_tsyjmkxkq4",
  type: "product",
  name: 'Acacia Heirloom Mini Cheese Board Set of 3 - 8x4.25" +ribbon',
  brandName: "Sophistiplate",
  imageUrl:
    "https://cdn.faire.com/fastly/39e084600c87730915833af7b0aabbf9bd1ff09f1fef2fc7130ee40b7c017894.png",
  priceDollars: 12.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/9d87cc1a312adc3b66246e924abe032d4ca60aa0d4d8a75a1237c4eb5d81f861.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
